import { render, staticRenderFns } from "./BaseEmergencyManage.vue?vue&type=template&id=4c5c6857&scoped=true&"
import script from "./BaseEmergencyManage.vue?vue&type=script&lang=js&"
export * from "./BaseEmergencyManage.vue?vue&type=script&lang=js&"
import style0 from "./BaseEmergencyManage.vue?vue&type=style&index=0&id=4c5c6857&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5c6857",
  null
  
)

export default component.exports